import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p>
        Сделано на{" "}
        <a
          href="https://zim-zim.uz/uz/kafe"
          target="_blank"
          rel="noopener noreferrer"
        >
          ZimZim.uz
        </a>
      </p>
    </div>
  );
};

export default Footer;
